import { RefMvtDistillationVCI } from './ref-mvt-distillation-vci.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { DateTimeConverter } from 'src/app/core/services/mapper/converters';
import * as moment from 'moment';

export class MvtDistillationVci{
  static jsonMap = {
    idDrevAOC: 'idDrevAOC',
    refMvtDistillationVCI: { key: 'idTypeDistillation', converter: new (DataIdConverterFactory.build(RefMvtDistillationVCI, 'refMvtDistillationVCI'))() },
    dateDistillation: { key: 'dateDistillation', converter: new DateTimeConverter() },
    volume: 'volume'
  };

  idDrevAOC: number;
  refMvtDistillationVCI: RefMvtDistillationVCI;
  dateDistillation: moment.Moment;
  volume: number;
}
